// src/features/criador/dispositivo.js
//
// Identificador do aparelho para o antifraude do programa (mesmo aparelho com
// várias contas indicadas, aparelho do próprio criador). No nativo usa o
// identificador do Capacitor Device; na web, um id aleatório persistido no
// navegador (é o melhor que a web oferece — limpar os dados gera outro).
//
// O id é enviado em POST /afiliados/indicacao e /afiliados/dispositivo; o
// backend guarda o hash em AFILIADOS_DISPOSITIVOS e na lista do usuário.

import { Capacitor } from "@capacitor/core";
import { API_BASE_URL } from "../../config/api";

const CHAVE_WEB = "LV_DEVICE_ID";

export function plataformaAtual() {
  try {
    return Capacitor.getPlatform(); // ios | android | web
  } catch {
    return "web";
  }
}

function idWeb() {
  try {
    let id = localStorage.getItem(CHAVE_WEB);
    if (!id) {
      id = `web-${(crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`)}`;
      localStorage.setItem(CHAVE_WEB, id);
    }
    return id;
  } catch {
    return "";
  }
}

export async function obterDeviceId() {
  if (plataformaAtual() === "web") return idWeb();
  try {
    // Import dinâmico: o plugin só existe no binário nativo.
    const { Device } = await import("@capacitor/device");
    const r = await Device.getId();
    return r?.identifier || r?.uuid || idWeb();
  } catch {
    return idWeb();
  }
}

/** Registra o aparelho da sessão atual (1x por login; best-effort). */
export async function registrarDispositivo(user) {
  if (!user) return;
  const chave = `LV_DEVICE_REG_${user.uid}`;
  try {
    if (sessionStorage.getItem(chave)) return;
    sessionStorage.setItem(chave, "1");
  } catch { /* segue */ }
  try {
    const [token, deviceId] = await Promise.all([user.getIdToken(), obterDeviceId()]);
    if (!deviceId) return;
    await fetch(`${API_BASE_URL}/afiliados/dispositivo`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ deviceId, plataforma: plataformaAtual() }),
    });
  } catch { /* antifraude é best-effort; nunca atrapalha o login */ }
}

/** Evento do funil do criador de quem indicou este usuário (paywall/checkout). */
export async function registrarEventoCriador(user, tipo, contexto = "") {
  if (!user || !["paywall_aberto", "checkout_app"].includes(tipo)) return;
  try {
    const token = await user.getIdToken();
    await fetch(`${API_BASE_URL}/afiliados/eventos`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ tipo, contexto: String(contexto || "").slice(0, 40) }),
      keepalive: true,
    });
  } catch { /* métrica nunca bloqueia a compra */ }
}
